interface SparklineProps {
  trend: "up" | "down" | "flat";
  className?: string;
}

const paths = {
  up: "M 0 20 Q 5 18 10 16 T 20 12 T 30 14 T 40 8 T 50 6 T 60 4",
  down: "M 0 4 Q 5 6 10 8 T 20 12 T 30 10 T 40 16 T 50 18 T 60 20",
  flat: "M 0 12 Q 5 10 10 14 T 20 11 T 30 13 T 40 10 T 50 12 T 60 11",
};

const Sparkline = ({ trend, className = "" }: SparklineProps) => {
  const color = trend === "up" ? "hsl(160, 100%, 50%)" : trend === "down" ? "hsl(14, 100%, 64%)" : "hsl(215, 72%, 53%)";

  return (
    <svg viewBox="0 0 60 24" className={`${className}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={`grad-${trend}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.3" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      {/* Fill area */}
      <path d={`${paths[trend]} L 60 24 L 0 24 Z`} fill={`url(#grad-${trend})`} />
      {/* Line */}
      <path d={paths[trend]} stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

export default Sparkline;
